import { connectInternalApi } from 'common/api'

interface MetabaseDashboardUrlResponse {
  url: string
}

type MetadataListResponse = {
  name: string
  id: string
  createdDate: string
}[]

// Mocking for now until BE is implemented
export const fetchMetadataList = async (): Promise<MetadataListResponse> => {
  return [
    {
      name: 'Thomas Test 2',
      id: 'a238f3e0-6043-4ef3-881b-7f8874f4c991',
      createdDate: '2025-05-08T12:00:00Z',
    },
    {
      name: 'Placeholder - no data',
      id: '12345',
      createdDate: '2025-05-23T12:00:00Z',
    },
  ]
}

export const fetchMetabaseDashboardUrl = async (
  dashboardId: string,
  accountId: string
): Promise<string> => {
  const url = `v1/metabase/dashboard/${dashboardId}/account/${accountId}`
  const response =
    await connectInternalApi.get<MetabaseDashboardUrlResponse>(url)

  return response.data?.url
}
